//
//
//
//
//
//
//
//
//
//
//
//
//

import Searchbar from '~/components/Searchbar';
import JobList from './_components/JobList';
import ErrorMsg from './_components/ErrorMsg';

export default {
  name: 'Jobs',
  components: {
    Searchbar,
    JobList,
    ErrorMsg,
  },
  data() {
    return {
      jobList: [],
      conditions: {},
      pagerInfo: { size: 12, current: 1, total: 0 },
      errorMsg: '',
    };
  },
  methods: {
    sortChange(payload) {
      this.conditions = { ...this.conditions, ...payload };
    },
    onSearch(resultData) {
      this.errorMsg = '';
      if (typeof resultData == 'string') {
        this.errorMsg = resultData;
      }
      this.jobList = resultData.records;

      const { current, size, total } = resultData;
      this.pagerInfo = { ...this.pagerInfo, current, size, total };

      if (process.browser) {
        window.scroll({
          top: this.$refs.searchbarArea.clientHeight,
          left: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  mounted() {
    let query = {};
    for (const [key, value] of Object.entries(this.$route.query)) {
      if (value !== null || value !== '') {
        query[key] = JSON.parse(this.$route.query[key]);
      }
    }
    this.conditions = { ...query, ...this.pagerInfo };
  },
};
